var bindFilters = {
    updateFilters (filter_id, datas) {
        if (typeof Filters != "undefined") {
            Filters.updateFilters(filter_id, datas);
        }
    },
    removeLocalizationOption () {
        PropertyResults.removeLocalizationOption();
    }
};

export default bindFilters